module.exports = __webpack_public_path__ + "static/media/10-things-that-every-web-developer-should-know.90b2d788.jpg";